import { ICONS_WEB } from "@miplatform/constants";
import { getUpdatedFields } from "@miplatform/utils";
import * as mdi from "@mdi/js";

export const usePlanMaterialViewModel = ({
  updateArea,
  area = {},
  item,
  dirtyFields,
  getValues,
  openDrawer,
  reset,
}) => {
  const handleRemoveMaterial = (materialId) => {
    const updatedAreaMaterials = area.materials.filter(
      (material) => material.materialId !== materialId
    );
    updateArea(area.id, { materials: updatedAreaMaterials });
    reset({ quantity: 1 });
  };

  const handleUpdateItem = () => {
    const updatedValues = getUpdatedFields(dirtyFields, getValues());
    const updatedAreaMaterials = area.materials.map((material) =>
      material.materialId === item.id
        ? { ...material, quantity: updatedValues.quantity }
        : material
    );
    if (!updatedValues.quantity) {
      return;
    }
    updateArea(area.id, { materials: updatedAreaMaterials });
  };

  const handleRemoveSuppliedBuilder = (materialId) => {
    const updatedAreaMaterials = area.materials.map((material) =>
      material.materialId === materialId
        ? { ...material, suppliedByBuilder: false }
        : material
    );
    updateArea(area.id, { materials: updatedAreaMaterials });
  };

  const isSuppliedByBuilder = area.materials?.find(
    (mat) => mat.materialId === item.id
  )?.suppliedByBuilder;

  const getMenuOptions = () => {
    const options = [
      {
        label: "View Notes",
        icon: mdi[ICONS_WEB.NOTE_TEXT_OUTLINE],
        action: openDrawer,
      },
      {
        label: "Remove Item",
        icon: mdi[ICONS_WEB.TRASH_CAN],
        action: () => handleRemoveMaterial(item.id),
      },
    ];

    if (isSuppliedByBuilder) {
      options.push({
        label: "Remove Supplied By Builder",
        icon: mdi[ICONS_WEB.ACCOUNT_OFF],
        action: () => handleRemoveSuppliedBuilder(item.id),
      });
    }

    return options;
  };

  return {
    handleUpdateItem,
    getMenuOptions,
    isSuppliedByBuilder,
  };
};
